import {
  AiFillInstagram,
  AiFillFacebook,
  AiFillGithub,
  AiFillLinkedin
} from "react-icons/ai";
import styles from "../styles/header.css";
import { motion } from "framer-motion";
import profilepic from "../images/profilepic.png"

const Header = () => {
  return (
    <motion.div
      className="header"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 0.2, duration: 0.5 }}
    >
      
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.5 }}
      >
        IOS Dev, User-Centric Design & Tech Innovator
      </motion.h1>
      <motion.h1
        className="caption title"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.5 }}
      >
        Crafting innovative iOS solutions for a better world.
      </motion.h1>
      {/* <motion.img
        src="https://media-exp1.licdn.com/dms/image/D4D03AQEeTW4m852KPw/profile-displayphoto-shrink_800_800/0/1669210672647?e=1675296000&v=beta&t=srMyB12Uc8BM6BjEp1tZZjE826BwJ9EgygmCM-nz0gA"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.5 }}
        style={{
          width: "200px"
        }}
      /> */}
      <motion.img
      className="header_img"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.5 }}
        src={profilepic}     />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 0.5 }}
        className="icons"
      >
        <a href="https://github.com/lexypaul13" target={"_blank"}>
          <AiFillGithub />
        </a>
        <a href="https://www.linkedin.com/in/lexypaul/" target={"_blank"}>
          <AiFillLinkedin />
        </a>
      </motion.div>
    </motion.div>
  );
};

export default Header;
